<div class="back-button">
  <div class="back-button__container">
    <img
      class="back-button__icon back-button__icon--desktop"
      mfpLazyImage
      lazySrc="assets/icons/arrow-small-red.svg"
      alt="Back button icon"
      [ngClass]="{ 'add-button__icon--no-margin': !label }"
    />
    <ng-container *ngIf="label">
      <span class="back-button__label">{{ label }}</span>
    </ng-container>
  </div>
</div>
